import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { useEffect, useReducer, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import usePagination from "../helpers/Pagination";
import { Header } from "../header";
import { useCountdownStore, useProfileStore } from "../helpers/state";
import { Assessment, Choose } from "../reducer/pektaReducer";
import { useLoginStore } from "../helpers/state";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Modal from "@mui/material/Modal";

toast.configure();

export function PektaTest() {
  const { login } = useLoginStore();
  const { profile } = useProfileStore();
  const [sendLoader, setSendLoader] = useState(false);
  let [qu, setQu] = useState([]);
  const questionsFetched = useRef(false);
  var CryptoJS = require("crypto-js");
  const bytes = CryptoJS.AES.decrypt(
    login.jwtToken,
    `${process.env.SECRET_KEY}`
  );
  var jwt = bytes.toString(CryptoJS.enc.Utf8);
  const userEmail = login.email;
  const navigate = useNavigate();
  let indexes;
  const [formValues, setFormValues] = useReducer(
    (curVal, newVal) => ({ ...curVal, ...newVal }),
    Assessment
  );
  const [selected, setSelected] = useReducer(
    (curVal, newVal) => ({ ...curVal, ...newVal }),
    Choose
  );
  let [page, setPage] = useState(1);
  const PER_PAGE = 6;
  const count = Math.ceil(qu.length / PER_PAGE);
  const _DATA = usePagination(qu, PER_PAGE);
  const totalQuestion = qu.length;

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  let trueCounter = 0;
  const passingMark = Math.ceil(totalQuestion / 2);
  let data, assessmentData, result;

  const handleSubmit = () => {
    for (let i = 0; i < totalQuestion; i++) {
      if (formValues[i] === true) {
        trueCounter++;
      }
    }
    if (trueCounter >= passingMark) {
      result = true;
    } else {
      result = false;
    }

    data = JSON.stringify({
      data: {
        title: `Pekta Test for ${userEmail}`,
        description: `Total Question ${totalQuestion}, Passing mark ${passingMark}`,
        question_count: totalQuestion,
        pass_mark: passingMark,
        is_active: true,
      },
    });

    let submitConfig = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/api/pekta-assessments`,
      headers: {
        Authorization: `Bearer ${jwt}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(submitConfig)
      .then((response) => {
        let assessmentId = response.data.data.id;

        assessmentData = JSON.stringify({
          data: {
            pekta_application: profile.pektaApp.id,
            question_count: totalQuestion,
            question_correct_count: trueCounter,
            is_pass: result,
            pekta_assessment: assessmentId,
          },
        });

        let assesmentConfig = {
          method: "post",
          url: `${process.env.REACT_APP_API_URL}/api/pekta-application-assessments`,
          headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "application/json",
          },
          data: assessmentData,
        };

        axios(assesmentConfig)
          .then((response) => {
            showMarks();
          })
          .catch((error) => {
            setSendLoader(false);
            console.log("An error occurred:", error.response);
          });
      })
      .catch((error) => {
        setSendLoader(false);
        console.log("An error occurred:", error.response);
      });
  };

  function index(i, j) {
    if (i === 1) {
      j = j + 1;
    } else if (i === 2) {
      j = j + 7;
    } else if (i === 3) {
      j = j + 13;
    } else if (i === 4) {
      j = j + 19;
    } else if (i === 5) {
      j = j + 25;
    } else if (i === 6) {
      j = j + 31;
    } else if (i === 7) {
      j = j + 37;
    } else if (i === 8) {
      j = j + 43;
    }
    indexes = j;
    return j;
  }

  function handleAnswer(value, i, j) {
    const no = index(page, i);
    setFormValues({ [no]: value });
    setSelected({ [no]: j });
  }
  const Answer = ({ ans, isSelected, onClick }) => {
    return (
      <div
        onClick={onClick}
        id={ans.id}
        value={ans.is_correct}
        style={{
          background: isSelected ? "Gainsboro" : "white",
        }}
        className="px-3 py-2 rounded-md block max-w-3xl w-full ml-6 text-justify cursor-pointer"
      >
        {JSON.stringify(ans.answer).slice(1, -1)}
      </div>
    );
  };

  async function retrieve() {
    try {
      let res = await axios({
        url: `${process.env.REACT_APP_API_URL}/api/pekta-assessment-questions?filters[is_active][$eq]=true&populate[1]=answers&filters[type][$eq]=pekta`,
        method: "get",
        timeout: 20000,
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      });

      const shuffledQuestions = [...res.data.data].sort(
        () => Math.random() - 0.5
      );

      setQu(shuffledQuestions);
    } catch (err) {
      console.log(err);
      toast.error("Gagal memuatkan soalan ujian. Sila cuba semula.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  function showMarks() {
    setSendLoader(false);
    // Clear the cameFromProfile flag
    sessionStorage.removeItem("cameFromProfile");

    Swal.fire({
      title: "",
      text: `Markah anda ialah ${trueCounter}/${totalQuestion}`,
      icon: "success",
      confirmButtonText: "Terus",
      allowOutsideClick: false,
      customClass: {
        confirmButton: "order-3",
        popup: "custom-swal-popup",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/myprofile");
      }
    });
  }

  useEffect(() => {
    if (!profile.pektaApp) {
      toast.warning("Sila membuat permohonan terlebih dahulu", {
        position: toast.POSITION.TOP_CENTER,
      });
      navigate("/myprofile");
      return;
    }

    if (
      profile.pektaApp.status === "approved" ||
      profile.pektaApp.status === "rejected"
    ) {
      toast.warning("Anda tidak dibenarkan membuat ujian PEKTA", {
        position: toast.POSITION.TOP_CENTER,
      });
      navigate("/myprofile");
      return;
    }

    if (questionsFetched.current) return;
    questionsFetched.current = true;
    retrieve();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.pektaApp, navigate]);

  function EndTest() {
    Swal.fire({
      showDenyButton: true,
      title: "Selesai Ujian?",
      text: "Anda pasti ingin menyelesaikan ujian ini?",
      icon: "question",
      confirmButtonText: "Terus",
      denyButtonText: "Batal",
      allowOutsideClick: false,
      customClass: {
        confirmButton: "order-3",
        popup: "custom-swal-popup",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setSendLoader(true);
        handleSubmit();
      } else {
        setSendLoader(false);
        window.removeEventListener(
          "beforeunload",
          CountdownComponent.handleBeforeUnload,
          { capture: true }
        );
      }
    });
  }

  function choice(j) {
    let result = "";
    if (j === 0) {
      result = "A";
    } else if (j === 1) {
      result = "B";
    } else if (j === 2) {
      result = "C";
    } else if (j === 3) {
      result = "D";
    }
    return result;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Header />

      <div className="bg-white mx-2 sm:mx-4 lg:mx-auto h-auto max-w-4xl p-3 sm:p-5 my-4 sm:my-6 rounded-lg shadow-sm">
        {/* Header Section - Mobile Optimized */}
        <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:justify-between sm:items-center mb-6">
          <div className="flex-1">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-800 leading-tight">
              Ujian Pemilihan PEKTA
            </h1>
          </div>

          {/* Countdown Timer - Mobile Optimized */}
          <div className="flex items-center justify-center sm:justify-end">
            <div className="bg-green-100 rounded-md px-3 py-2 text-sm sm:text-base text-gray-700 whitespace-nowrap">
              <span className="font-medium">Masa menjawab:</span>
              <span className="ml-2 font-mono font-bold">
                <CountdownComponent handleSubmit={handleSubmit} />
              </span>
            </div>
          </div>
        </div>

        {/* Questions Section - Mobile Optimized */}
        <div className="space-y-6">
          {_DATA.currentData().map((v, i) => (
            <div
              className="border-b border-gray-100 pb-6 last:border-b-0"
              key={v.id}
            >
              {/* Question */}
              <div className="mb-4">
                <div className="flex items-start space-x-2 mb-3">
                  <span className="font-bold text-lg text-gray-800 flex-shrink-0">
                    {index(page, i)}.
                  </span>
                  <p className="text-base sm:text-lg text-gray-800 leading-relaxed">
                    {JSON.stringify(v.attributes.question).slice(1, -1)}
                  </p>
                </div>
              </div>

              {/* Answers - Mobile Optimized */}
              <div className="space-y-3 pl-6 sm:pl-8">
                {v.attributes.answers.map((ans, j) => (
                  <div className="flex items-start space-x-3" key={ans.id}>
                    {/* Choice Button */}
                    <button
                      onClick={() => handleAnswer(ans.is_correct, i, ans.id)}
                      className={`flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full text-white font-bold text-sm sm:text-base transition-all duration-200 ${
                        ans.id === Object.values(selected)[indexes - 1]
                          ? "bg-black ring-2 ring-gray-400 scale-105"
                          : "bg-gray-600 hover:bg-gray-700"
                      }`}
                    >
                      {choice(j)}
                    </button>

                    {/* Answer Text */}
                    <div className="flex-1">
                      <Answer
                        ans={ans}
                        isSelected={
                          ans.id === Object.values(selected)[indexes - 1]
                        }
                        onClick={() => handleAnswer(ans.is_correct, i, ans.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Submit Button - Mobile Optimized */}
        <div className="mt-8 flex justify-center sm:justify-end">
          <button
            className={`px-6 py-3 rounded-lg font-medium text-white transition-all duration-200 ${
              page === 5
                ? "bg-lime-600 hover:bg-lime-700 shadow-md hover:shadow-lg"
                : "invisible"
            }`}
            onClick={EndTest}
          >
            <span className="flex items-center space-x-2">
              <span>Hantar</span>
              <span>➜</span>
            </span>
          </button>
        </div>

        {/* Pagination - Mobile Optimized */}
        <div className="mt-8 w-full overflow-x-auto">
          <Stack direction="row" justifyContent="center" width="100%">
            <Pagination
              count={count}
              size={window.innerWidth < 640 ? "medium" : "large"}
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
              sx={{
                "& .MuiPaginationItem-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  minWidth: { xs: "32px", sm: "40px" },
                  height: { xs: "32px", sm: "40px" },
                },
              }}
            />
          </Stack>
        </div>
      </div>

      {/* Loading Modal */}
      <Modal
        open={sendLoader}
        onClose={() => console.log("close")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          zIndex: 100,
        }}
      >
        <div className="flex justify-center items-center h-screen bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-8 flex flex-col items-center space-y-4">
            <CircularProgress color="success" size={80} />
            <p className="text-gray-700 font-medium">Menghantar jawapan...</p>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export const CountdownComponent = ({ handleSubmit }) => {
  const { countdown, decrementCountdown } = useCountdownStore();

  const handleSavedTimestamp = () => {
    const savedTimestampString = sessionStorage.getItem("countdownTimestamp");
    if (!savedTimestampString) {
      sessionStorage.setItem("countdownTimestamp", Date.now().toString());
    }
  };

  useEffect(() => {
    handleSavedTimestamp();

    const countdownInterval = setInterval(() => {
      decrementCountdown();
    }, 1000);

    if (countdown > 0) {
      window.addEventListener("beforeunload", (e) => {
        e.preventDefault();
        e.returnValue = "";
        if (
          !window.confirm(
            "Are you sure you want to reload? Progress will be lost"
          )
        ) {
          return;
        }

        sessionStorage.setItem("countdown", countdown);
        sessionStorage.setItem("countdownTimestamp", Date.now().toString());
        window.location.reload();
      });
    }

    return () => clearInterval(countdownInterval);
  }, [decrementCountdown, countdown]);

  useEffect(() => {
    if (countdown === 0) {
      Swal.fire({
        title: "Ujian Pemilihan PEKTA",
        text: "Masa menjawab sudah tamat, semua soalan dijawab akan dihantar untuk semakan.",
        icon: "info",
        confirmButtonText: "Terus",
        allowOutsideClick: false,
        customClass: {
          confirmButton: "order-3",
          popup: "custom-swal-popup",
        },
      })
        .then((result) => {
          if (result.isConfirmed) {
            handleSubmit();
          }
        })
        .catch((error) => {
          console.error("Error displaying Swal alert:", error);
        });
    }
  }, [countdown, handleSubmit]);

  return <div>{formatTime(countdown)}</div>;
};

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${String(minutes).padStart(2, "0")}:${String(
    remainingSeconds
  ).padStart(2, "0")}`;
};
